import React, { useState,useEffect,useMemo } from "react";
import styled from "styled-components";
import { Tab } from "../../Reusablecomponents/Tab";
import TripReport from "./TripReports";
import KpiReports from "./kpiReports";
import CarbonReport from "./carbonReport";
import {
  Radio,
} from "antd";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
const GreenRadio = styled(Radio)`
  .ant-radio-inner {
    border-color: green; // Change the border color
  }
  .ant-radio-checked .ant-radio-inner {
    background-color: green; // Change the background color when checked
    border-color: green; // Change the border color when checked
  }
  .ant-radio-wrapper {
    color: green; // Change the text color
  }
`;

const Customstyle = styled.div`
  background-color: white;

  .topstyle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
  }
  @media (max-width: 480px) {
    .ant-tabs .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 7px;
    }
    .ant-tabs-nav-list {
      flex-direction: column;
      margin: 0px 0px 0px 8px;
    }
    .topstyle {
      flex-direction: column;
      gap: 10px;
    }
    .searchstle {
      flex-direction: column;
      align-self: flex-end;
    }
    .total {
      align-self: flex-start;
    }
  }
  .ant-tabs-nav-list {
    margin-top: 20px;
  }
  .total {
    color: #5f6d8c;
    font-size: 16px;
    font-weight: 400;
  }
  .searchstle {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .filterstyle {
    height: 25px;
    width: 25px;
  }
  .badg {
    padding: 6px;
  }
  .custom-row-height {
    height: 88px !important; /* Set desired row height */
  }
  .tablestyle {
    // padding-left: 30px;
  }
  .switc {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .create_btn_customization {
    margin-left: auto;
  }
`;

const ContainerReports = () => {
  const [activekey, setactivekey] = useState("1");
  const [selectedReport, setSelectedReport] = useState("Trips"); // State to track selected radio button
 const location = useLocation();
 //navigate the kpi report page on home page KPI ALERTS
  useEffect(() => {
    if (location.state?.tab) {
      setactivekey(location.state.tab); 
    }
  }, [location.state]);

    const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
        const cargoTripReportRead = useMemo(
      () => hasPermission("CONT_TRPT", "R"),
      [reduxPermissions],
    );
            const cargoKPIReportRead = useMemo(
      () => hasPermission("CONT_KRPT", "R"),
      [reduxPermissions],
    );
            const cargoCarbonReportRead = useMemo(
      () => hasPermission("CONT_CRPT", "R"),
      [reduxPermissions],
    ); 

  const tabItems = [
    { label: "Trip Reports", key: "1" },
    { label: "KPI Reports", key: "2" },
    { label: "Carbon Footprint Report", key: "3" },
  ];
  return (
    <Customstyle>
      <Tab defaultActiveKey="1" items={tabItems} onChange={setactivekey} />
      <div className="px-3">
        {activekey === "1" && <div className="topstyle"></div>}
        {activekey === "2" && <div className="topstyle"></div>}
        {activekey === "3" && <div className="topstyle"></div>}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between", // Align title to the left and icons to the right
          alignItems: "center",
        }}
        className="px-3"
      >
      </div>

      {activekey === "1" && cargoTripReportRead && (
        <>
          <div className="px-3" style={{ marginTop: "16px" }}>
            {selectedReport === "Trips" && <TripReport />}
          </div>
        </>
      )}
      {activekey === "2" && cargoKPIReportRead && (
        <div className="px-3" style={{ marginTop: "16px" }}>
          <KpiReports />
        </div>
      )}
      {activekey === "3" && cargoCarbonReportRead && (
        <div className="px-3" style={{ marginTop: "16px" }}>
          <CarbonReport />
        </div>
      )}
    </Customstyle>
  );
};

export default ContainerReports;
